import { DefaultButton, Modal } from '@fluentui/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { FileUploader } from 'react-drag-drop-files';
import ProgressBar from '../ProgressBar';
import ConfirmModal from '../../../../components/Modal/ConfirmModal';
import studylistContext from "../../../../context/studylist/StudylistContext";
import { useTranslation } from 'react-i18next';
import userContext from '../../../../context/users/UserContext';
import { USERTYPES } from '../../../../constants/Constants';
import ModalMain from '../../../../components/Modal/ModalMain';
import UploadStudyBody from './UploadStudyBody';
import { useFormik } from 'formik';
import { StudyUploadSchema } from './StudyUploadSchema';
import Moment from "moment";
import ProgressBarContext from '../../../../context/progressbar/ProgressBarContext';

const UploadStudy = (props) => {

    let enterprise = (process.env.REACT_APP_ENTERPRISE_PLATFORM=="true"||process.env.REACT_APP_ENTERPRISE_PLATFORM==true)?true:false;
    const {roles,userId } = useContext(userContext);
    const [t]  = useTranslation();
    const {studyData,dataQueryState,minimalClientFirmList} = useContext(studylistContext);
    const clientFirmList = studyData.clientFirmList;
    const [hospOrFirmList, setHospOrFirmList] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmModalMessage, setConfirmModalMessage] = useState("");
    const [isUploadAllowed, setIsUploadAllowed] = useState(true);
    const [filesUploaded, setFilesUploaded] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [refreshAfterUpload,setRefreshAfterUpload] = useState(false);
    const [patientDetails, setPatientDetails] = useState({});
    const [filterObj, setFilterObj] = useState({});
    const [uploadStudyPayload, setUploadStudyPayload] = useState({});
    const [isJpg, setIsJpg] = useState(false);
    const [jpgErrorMessage, setJpgErrorMessage] = useState("");
    const [showJpgErrorMessage, setshowJpgErrorMessage] = useState(false);
    const [dicomErrorMessage, setDicomErrorMessage] = useState("");
    const [showDicomErrorMessage, setShowDicomErrorMessage] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState(t("upload-study.no-file-selected"));
    const [dicomClientDropDownError, setDicomClientDropDownError] = useState('');
    const [dicomFirmDropDownError, setDicomFirmDropDownError] = useState('');
    const [jpgClientDropDownError, setJpgClientDropDownError] = useState('');
    const [jpgFirmDropDownError, setJpgFirmDropDownError] = useState('');
    const [showUploadStudyModal, setShowUploadStudyModal] = useState(true);
    // const [progressObjs, setProgressObjs] = useState([]);
    const {progressObjs, updateProgressObj, progressBarId, setProgressBarId} = useContext(ProgressBarContext);
    const divRef = useRef();

    // let progressBarId = 0;
    let newList = []; 
    let newJpgList = []; 
    let fileNames = useRef(new Array());
    let [uploadFiles, setUploadFiles] = useState([]);
    let [uploadJpgFiles, setUploadJpgFiles] = useState([]);
    let [hospital, setHospital] = useState('');
    const fileTypes = ["JPEG", "PNG", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/octet-stream", "text/plain", "application/msword", "DCM"];

    const hideUploadStudyModal = () =>{
        props.setShowUploadStudyModal(false);
        setHospital("");
        setUploadFiles([]);
        if(refreshAfterUpload){
            setRefreshAfterUpload(false);
            dataQueryState.refetch();
        }
       
    }

    const formatDate = (date) => {
        var currentDate = Moment(date).local().format("DD-MMM-YYYY");
        return date == "" ? "" : currentDate;
      };

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        setValues,
        setErrors
      } = useFormik({
        initialValues:  {
          patientName: patientDetails?.patientName,
          patientId: patientDetails.patientId,
          modality: filterObj.modality,
          age: patientDetails.age,
          sex: "",
          dob: "",
          accessionNumber: patientDetails.accessionNumber,
          clientId: "",
          files: ""
      },
        enableReinitialize: true,
        validationSchema: StudyUploadSchema,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values) => {
        if((roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && (!filterObj.jpgFirmId || filterObj.jpgFirmId === "" || filterObj.jpgFirmId === -1)){
            setJpgFirmDropDownError("Please select the firm before uploading the study");
            return;
        }else if(!(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && (!filterObj.jpgMinimalClientId || filterObj.jpgMinimalClientId === "" || filterObj.jpgMinimalClientId === -1)){
            setJpgClientDropDownError("Please select the client before uploading the study");
            return;
        }
        setJpgFirmDropDownError('');
        setJpgClientDropDownError('');
        if(!filterObj.files  || filterObj.files.length === 0){
            setJpgErrorMessage(t("upload-study.please-select-file"));
            setshowJpgErrorMessage(true);
            return;
        }else{
            const firstFile = filterObj.files[0];
            const maxSizeInBytes = 15 * 1024 * 1024;
            if (firstFile.size > maxSizeInBytes) {
              setJpgErrorMessage(t("upload-study.file-too-large"));
              setshowJpgErrorMessage(true);
              return;
            }

            const allowedExtensions = ["jpg", "jpeg", "png"]; 
            const fileExtension = firstFile.name.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
            setJpgErrorMessage(t("upload-study.select-image-file"));
            setshowJpgErrorMessage(true);
            return;
            }
          
            setshowJpgErrorMessage(false);
        }
        const payload = getUploadStudyPayload(values);
        setUploadStudyPayload(payload);
        }
      });

      useEffect(() => {
        if(Object.keys(uploadStudyPayload).length > 0){
            if(filterObj.files)
                handleFileUploadChange(filterObj.files);
        }
      },[uploadStudyPayload]);

      useEffect(() => {
        if(minimalClientFirmList.length == 0 && roles[0] == USERTYPES.RADIOLOGIST){
            setShowUploadStudyModal(false);
        }
      },[]);

      const getUploadStudyPayload = (values) =>{
        let clientId = "";
        if((roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && filterObj.jpgMinimalClientId == -1){
            clientId =  filterObj.jpgFirmId;
        }else if(filterObj.jpgMinimalClientId)
            clientId =  filterObj.jpgMinimalClientId;

        return ({
            patientName: values.patientName ? values.patientName : "",
            patientId: values.patientId ? values.patientId : "" ,
            patientSex: filterObj.sex ? filterObj.sex : "",
            patientAge: values.age ? values.age : "",
            birthdate: filterObj.dob == null ? null : formatDate(filterObj.dob),
            modality: 'CR',
            isJpg: isJpg,
            accessionNumber: values.accessionNumber ? values.accessionNumber : "",
            selectedClientId: clientId,
            clientId:  clientId
        })
      }

    const handleHospOrFirmList = () =>{
        let list = clientFirmList.map((clientOrFirm)=>{
            return {key:clientOrFirm.id, text:clientOrFirm.name};
        })
        setHospOrFirmList(list);
    }


    const DefaultButtonList = [
        {
            title:t("button.close"),
            onclick: hideUploadStudyModal
        }
    ];
    let PrimaryButtonList = [];
    if (isJpg) {
        PrimaryButtonList.unshift({
          title: t("button.upload"),
          onclick: handleSubmit 
        });
      }

    const handleHospital = (event, selected) =>{
        setHospital(selected.key);
    }

    const handleHospitalAlert = () =>{
        setShowConfirmModal(false);
        if(confirmModalMessage == t("upload-study.upload-not-allowed")){
            hideUploadStudyModal();
        }
    }

    const handleFileUploadChange = async(fileList) => {
        if(enterprise && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR) && hospital === ""){
            setConfirmModalMessage("You need to select hospital first.");
            setShowConfirmModal(true);
            return;
        }else if(!enterprise){
            if(!isJpg){
                if((roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && (!filterObj.firmId || filterObj.firmId === "" || filterObj.firmId === -1)){
                    setDicomFirmDropDownError("Please select the firm before uploading the study");
                    return;
                }else if(!(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && (!filterObj.minimalClientId || filterObj.minimalClientId === "" || filterObj.minimalClientId === -1)){
                    setDicomClientDropDownError("Please select the client before uploading the study");
                    return;
                }
            }else{
                if((roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && (!filterObj.jpgFirmId || filterObj.jpgFirmId === "" || filterObj.jpgFirmId === -1)){
                    setJpgFirmDropDownError("Please select the firm before uploading the study");
                    return;
                }else if(!(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && (!filterObj.jpgMinimalClientId || filterObj.jpgMinimalClientId === "" || filterObj.jpgMinimalClientId === -1)){
                    setJpgClientDropDownError("Please select the client before uploading the study");
                    return;
                }
            }

        }
        setDicomFirmDropDownError('');
        setDicomClientDropDownError('');
        setJpgFirmDropDownError('');
        setJpgClientDropDownError('')
        console.log("1", fileList);
        let list = [];
        const payload = {
            studyId : "577",
            hospital: hospital,
        }

        const currentFiles = Object.keys(fileList).length;
        console.log(currentFiles)
        console.log(filesUploaded)
        if(currentFiles + filesUploaded > 25) {
            if(currentFiles > 25) {
                setIsUploadAllowed(false);
                setErrorMessage("You can only upload upto 25 files at a time. Please select maximum 25 files for processing.")
            } else {
                setIsUploadAllowed(false);
                setErrorMessage("Please wait to complete the processing for previously uploaded files.")
            }
            return;
        }
        for (let [key, value] of Object.entries(fileList)){
            let zipMimeType = ['application/x-rar-compressed', 'application/octet-stream', 'application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'];
            let fileType = value.type;
            let isZipFile = zipMimeType.indexOf(fileType) >= 0;
            if (!isJpg && fileType !== "" && !isZipFile && fileType !== "image/jpeg" && fileType !== "image/jpg" && fileType !== "application/dicom") {
                setShowDicomErrorMessage(true);
                setDicomErrorMessage("Please select only DICOM or ZIP files.");
                return;
            } else if (isJpg && fileType !== "" && fileType !== "image/jpeg" && fileType !== "image/jpg" && fileType !== "image/png") {
                setshowJpgErrorMessage(true);
                setJpgErrorMessage("Please select only JPEG, JPG or PNG file.");
                return;
            }
        };

        for (let [key, value] of Object.entries(fileList)){
            const extension = value.name.split('.').pop();
            console.log(extension)
            if(!fileNames.current.includes(value.name, 0)){
                list.push(
                    {
                        name:value.name,
                        isRendered:false
                    }
                );
                const formData = new FormData();
                const body = JSON.stringify(userId);
                const blob = new Blob([body], {
                    type: 'application/json'
                })
                formData.append("userId",blob);
                formData.append("file", value);
                if(isJpg){
                    Object.entries(uploadStudyPayload).forEach(([key, value]) => {
                        formData.append(key, value);
                    });
                }
                else{
                    formData.append("isJpg", false);
                    if((roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && filterObj.minimalClientId == -1){
                        formData.append("clientId", filterObj.firmId);
                    }else if(filterObj.minimalClientId)
                        formData.append("clientId", filterObj.minimalClientId);
                }
                setRefreshAfterUpload(true);
                console.log("filter obj");
                console.log(filterObj);
                const newProgressObj = {
                    isJpg: isJpg,
                    progress: 0, 
                    progressMessage: '',
                    progressBarId : progressBarId,
                    uploadStatus: 0,
                    setSelectedFileName:setSelectedFileName,
                    setValues:setValues,
                    formData:formData,
                    height:10,
                    fileName: value.name ,
                    isZip :extension === "zip",
                    setFilterObj: setFilterObj,
                    divRef: divRef,
                };
                updateProgressObj(newProgressObj);
                setProgressBarId(progressBarId + 1);
            }
        }
        setFilesUploaded(filesUploaded + newList.length);
        if(isJpg){
            setUploadJpgFiles(uploadJpgFiles.concat(newJpgList))
            if(props.divRef)
                props.divRef.current.scrollTop = props.divRef.current.scrollHeight;
        }else
            setUploadFiles(uploadFiles.concat(newList));
    
      };  

      useEffect(()=>{
        handleHospOrFirmList()
      },[]);

      useEffect(() => {
        console.log("fileter obj");
        console.log(filterObj);
      }, [filterObj]);

      const modalDetails = {
        header: <ModalHeader updatedModal={true} showPatientDetails={false} heading={t("upload-study.title")} handleCancel={hideUploadStudyModal}/>,
        body: <UploadStudyBody 
                hospOrFirmList={hospOrFirmList} 
                handleHospital={handleHospital} 
                handleFileUploadChange={handleFileUploadChange} 
                uploadFiles={uploadFiles} 
                uploadJpgFiles ={uploadJpgFiles}
                isUploadAllowed={isUploadAllowed} 
                errorMessage = {errorMessage} 
                patientDetails={patientDetails} 
                setPatientDetails ={setPatientDetails}
                setIsJpg = {setIsJpg}
                handleChange ={handleChange}
                values = {values}
                setValues = {setValues}
                errors = {errors}
                handleSubmit = {handleSubmit}
                filterObj = {filterObj}
                setFilterObj = {setFilterObj}
                showJpgErrorMessage ={showJpgErrorMessage}
                setshowJpgErrorMessage = {setshowJpgErrorMessage}
                jpgErrorMessage = {jpgErrorMessage}
                selectedFileName = {selectedFileName}
                setSelectedFileName = {setSelectedFileName}
                divRef={divRef}
                dicomClientDropDownError = {dicomClientDropDownError}
                dicomFirmDropDownError = {dicomFirmDropDownError}
                jpgClientDropDownError = {jpgClientDropDownError}
                jpgFirmDropDownError = {jpgFirmDropDownError}
                setShowConfirmModal ={setShowConfirmModal}
                setConfirmModalMessage = {setConfirmModalMessage}
                showDicomErrorMessage = {showDicomErrorMessage}
                dicomErrorMessage = {dicomErrorMessage}
                />,
        footer: <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList}/>,
        width: "700px"
      }

  return (
    <div>
        {showConfirmModal &&
            <ConfirmModal handleConfirm={handleHospitalAlert}  setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={confirmModalMessage}
            title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
        }
        {showUploadStudyModal && <ModalMain updatedModal={true} showModal={props.showUploadStudyModal} modalDetails={modalDetails}/>}
      </div>
  )
}

export default UploadStudy